import React from 'react';
import Alert from 'modules/shared/components/alert';
import Link from 'atomic/link';

import './search-no-result.scss';

const SearchNoResult: React.FC<{ query: string; categoryName?: string; allCategoriesUrl?: string; }> = ({ query, categoryName, allCategoriesUrl }) => {
    return (
        <div className="search-no-result">
            <Alert color="warning">
                Nie znalezliśmy wyników wyszukiwania dla zapytania “{query}”
                {categoryName ? ` w kategorii “${categoryName}”` : ''}
            </Alert>
            {allCategoriesUrl && (
                <Link href={allCategoriesUrl} type="button" color="primary"
                    size="lg"
                >
                    Wyszukaj we wszystkich kategoriach
                </Link>
            )}
        </div>
    );
};

export default SearchNoResult;
